import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared/base-api-template-service.model';
import {Core2Config} from '../../shared/core2Config';
import { CompanyEmployeeLinkContainer } from '../../../../../../models/aggregates/erp/company-employee-link';

@Injectable({
  providedIn: 'root'
})
export class CompanyEmployeeLinkService extends BaseApiTemplateService<CompanyEmployeeLinkContainer> {

  readonly url = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'companies/company-employee-links/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'companies/company-employee-links/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'companies/company-employee-links/backoffice-ep';
    this.httpClient = http;
  }
}
